import jquery from 'jquery'
window.jQuery = jquery;
jQuery = jquery;
window.$ = jquery;
